function reArangeEventsPerPageFor2Column (events) {
  let result = []

  if (events && Array.isArray(events) && events.length > 0) {
    let oldNumberOfPages = events[events.length - 1].eventPage ? events[events.length - 1].eventPage : 0
    let counter = 0

    // Go trough all pages
    for (var i = 0; i <= oldNumberOfPages; i++) {
      let eventsOnPage = events.filter((ev) => {
        return ev.eventPage === i
      })

      // Events on 1. column
      let firstColumnOnPage = eventsOnPage.filter((ev) => {
        return ev.displaycol === 1
      })
      // Events on 2. column
      let secondColumnOnPage = eventsOnPage.filter((ev) => {
        return ev.displaycol === 2
      })

      // Determen new page for event
      firstColumnOnPage.forEach((ev, i) => {
        ev.statsPage = counter
      })

      counter++

      secondColumnOnPage.forEach((ev, i) => {
        ev.statsPage = counter
      })

      counter++
    }

    // Assign new page and column to events
    events.forEach((ev, i) => {
      ev.eventPage = ev.statsPage
      ev.displaycol = 1
      delete ev.statsPage
    })

    result = events
  }

  return result
}

function reArangeMarketsPerPageForSingleEvent (markets) {
  if (markets && Array.isArray(markets) && markets.length > 0) {

  }
}

export default {
  reArangeEventsPerPageFor2Column,
  reArangeMarketsPerPageForSingleEvent
}



// WEBPACK FOOTER //
// ./src/library/cdu/templates/stats.js